import { Box, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import countries from './countries-new.json';
import { COLORS } from '../../services/constants/colors';
import { CountryFlag } from '../CountryFlag';

export type TCountryWithFlagProps = {
	countryCode: string;
	size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
	sx?: {
		[key: string]: string | number;
	};
	bold?: boolean;
	color?: string;
	showLabel?: boolean;
	tooltip?: boolean;
};

export const CountryWithFlag: FC<TCountryWithFlagProps> = ({
	countryCode,
	size = 'm',
	sx = {},
	bold = false,
	color,
	showLabel = true,
	tooltip = true,
}) => {
	const country = countries?.find?.((cntr) => cntr?.code === countryCode);
	if (!country) return null;
	return (
		<Tooltip
			title={tooltip ? (country?.label ?? countryCode) : ''}
			disableFocusListener={!tooltip}
			disableHoverListener={!tooltip}
			disableTouchListener={!tooltip}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
				}}
			>
				<CountryFlag countryCode={countryCode} size={size} />
				<Typography
					// variant="body1"
					sx={{
						...sx,
						fontSize:
							size === 'xs'
								? '.6rem'
								: size === 's'
									? '.7rem'
									: size === 'm'
										? '.8rem'
										: size === 'l'
											? '.9rem'
											: size === 'xl'
												? '1rem'
												: size === 'xxl'
													? '1.1rem'
													: '.8rem',
						fontWeight: bold ? 'bold' : 'normal',
						color: COLORS.font_main,
					}}
					color={color}
				>
					{showLabel ? (country?.label ?? countryCode) : countryCode}
				</Typography>
			</Box>
		</Tooltip>
	);
};
